import React from "react";
import { Global } from "@emotion/react";
import { globalStyles } from "./styles/globalStyles";
import { AppStore } from "./store/app-store";
import Cookie from "js-cookie";
import {
  LOCALE_MISMATCH_COOKIE,
  PREFERRED_LOCALE_COOKIE_KEY,
  PREFERRED_SEGMENT_KEY_COOKIE_KEY,
  PREFERRED_SEGMENT_SELECTOR_COOKIE_KEY,
  PublicConfigurationT,
} from "@swo/shared";
import { parseSwarovskiOptikSegment } from "@swo/shared";

export function AppShell({ children, config }: { config: PublicConfigurationT; children: React.ReactNode }) {
  const authServiceHost = new URL(window.location.origin);
  const withLocaleMismatchOverlay = !!Cookie.get(LOCALE_MISMATCH_COOKIE);

  const preferredSegmentKey_ = Cookie.get(PREFERRED_SEGMENT_KEY_COOKIE_KEY);
  const prefferedSegmentKey =
    preferredSegmentKey_ && parseSwarovskiOptikSegment(preferredSegmentKey_) ? preferredSegmentKey_ : undefined;

  return (
    <React.StrictMode>
      <AppStore
        authServiceHost={authServiceHost}
        config={config}
        locationOrigin={new URL(window.location.origin)}
        preferredLocaleCode={Cookie.get(PREFERRED_LOCALE_COOKIE_KEY)}
        preferredSegmentKey={prefferedSegmentKey}
        shouldDisplaySegmentPickerOverlay={!!Cookie.get(PREFERRED_SEGMENT_SELECTOR_COOKIE_KEY)}
        withLocaleMismatchOverlay={withLocaleMismatchOverlay}
      >
        <Global styles={globalStyles} />

        {children}
      </AppStore>
    </React.StrictMode>
  );
}
